<template>
    <BaseAlert variant="danger" class="l-inline l-center-v">
        <template #alt>
            <div class="l-inline l-spread l-center-v l-full-width">
                <div>
                    {{ warning.title }}
                </div>
                <BaseButton
                    variant="danger"
                    size="small"
                    class="l-inline l-gap-1 l-center-v"
                    @click="dismissWarning(warning.id)"
                >
                    <CheckIcon width="16" height="16" color="currentcolor" />
                    <div>{{ $t('acknowledgeError') }}</div>
                </BaseButton>
            </div>
        </template>
    </BaseAlert>
</template>

<script>
import BaseAlert from '@/components/base/BaseAlert.vue'
import BaseButton from '@/components/redesigned/BaseButton.vue'
import CheckIcon from '@/components/icons/CheckIcon.vue'

import { mapActions } from 'vuex'

export default {
    name: 'WarningAlert',
    components: {
        BaseAlert,
        BaseButton,
        CheckIcon,
    },
    props: {
        warning: {
            type: Object,
            required: true,
        },
    },
    methods: {
        ...mapActions('warnings', ['dismissWarning']),
    },
}
</script>

<i18n>
{
    "en": {
        "acknowledgeError": "Acknowledge Error"
    },
    "de": {
        "acknowledgeError": "Fehler quittieren"
    },
    "fr": {
        "acknowledgeError": "Reconnaître l'erreur"
    },
    "it": {
        "acknowledgeError": "Riconosci l'errore"
    }
}
</i18n>
